import React from 'react'
import { Link } from 'react-router'

export default class NavLink extends React.Component {
  render() {
    return (
      <Link
        {...this.props}
        className="link f6 normal near-white ph3"
        activeClassName="fw6 white"
      />
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/MainNavigation/NavLink.js